export const GRID_RADIUS = 7;
export const FLOOR_SIZE = GRID_RADIUS * 2;
export const WALL_HEIGHT = 3.5;

// Isometric camera — true isometric angles
// Camera looks from (1,1,1) direction, 45 deg Y rotation, ~35.264 deg elevation
export const ISO_CAMERA_DISTANCE = 20;
export const ISO_CAMERA_POSITION: [number, number, number] = [
  ISO_CAMERA_DISTANCE,
  ISO_CAMERA_DISTANCE * Math.tan(Math.atan(1 / Math.SQRT2)),
  ISO_CAMERA_DISTANCE,
];
// Orthographic zoom: pixels per world unit.
// ~28 lets a 20-unit room fill ~560px — comfortable for most viewports.
export const ISO_ZOOM_DEFAULT = 28;
export const ISO_ZOOM_MIN = 14;
export const ISO_ZOOM_MAX = 60;

// Room materials
export const FLOOR_COLOR = "#e8dcc8";
export const WALL_COLOR = "#f5f0e8";
export const BASEBOARD_COLOR = "#c4b89a";
export const WINDOW_FRAME_COLOR = "#b8a88a";
export const CLEAR_COLOR = "#06090d";

// Placement
export const PLACEMENT_SIZES = {
  small: 0.5,
  medium: 1,
  large: 2,
} as const;
